import { ActionTypes } from "@/store/modules/Auth/actions-types";
import { store } from "@/store/store";
import { Route, RouteConfig } from "vue-router";

import Dashboard from "@/views/Dashboard/Dashboard.vue";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Connection",
    component: (): any => import("@/views/Auth/Connection/Connection.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/devices",
    name: "Device",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/surveys",
    name: "Survey",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/logs",
    name: "Log",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/users",
    name: "User",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/categories",
    name: "Categorie",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/agences",
    name: "Agence",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/device",
    name: "DeviceDescription",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/survey",
    name: "SurveyDescription",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/poste",
    name: "PosteDescription",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/reset_password",
    name: "ResetPassword",
    component: (): any => import("@/views/Auth/ResetPassword/ResetPassword.vue"),
    meta: {
      requiresAuth: false
    },
    beforeEnter: async (_to: Route, _from: Route, next: any): Promise<void> => {
      const temporary_token = new URLSearchParams(window.location.search).get("temporary_token");
      if (!temporary_token) next({ path: "/" });
      else {
        const result = await store.dispatch(ActionTypes.VERIFY_TEMPORARY_TOKEN, String(temporary_token));
        if (result !== 200) return next({ path: "/" });
        else next();
      }
    }
  },
  {
    path: "*",
    component: (): any => import("@/views/Error/NotFound/NotFound.vue")
  }
];

export default routes;
